import React from 'react';

import { InjectedIntl, injectIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import Button from '@atlaskit/button/custom-theme-button';
import Spinner from '@atlaskit/spinner';

import { LoadingStatus } from 'src/constants/loading-status';
import { fetchAvailableIssueTransitions } from 'src/redux/jira/actions';
import { PullRequestJiraIssuesState } from 'src/redux/jira/reducers/pull-request-jira-issues';
import { BucketState } from 'src/types/state';

import messages from './issue-transition-form.i18n';
import * as styles from './issue-transition-form.style';

type IssueTransitionErrorFormProps = {
  intl: InjectedIntl;
};

const IssueTransitionErrorForm = ({ intl }: IssueTransitionErrorFormProps) => {
  const pullRequestJiraIssuesState = useSelector<
    BucketState,
    PullRequestJiraIssuesState
  >(state => state.jira.pullRequestJiraIssues);
  const dispatch = useDispatch();

  const { issueTransitionFormData } = pullRequestJiraIssuesState;

  const failedTransitions = issueTransitionFormData.filter(
    row => row.availableIssueTransitionsFetchedStatus === LoadingStatus.Failed
  );

  const retryFetchIssueTransitions = () => {
    failedTransitions.map((_, index) =>
      dispatch(fetchAvailableIssueTransitions(index))
    );
  };

  return (
    <styles.ErrorContainer>
      <styles.LineContainer>
        <styles.SpinnerContainer>
          <Spinner size="small" />
        </styles.SpinnerContainer>
        {failedTransitions.length > 0 ? (
          <>
            <styles.ErrorMessage>
              {intl.formatMessage(messages.fetchTransitionsFailed)}
            </styles.ErrorMessage>
            <Button appearance="link" onClick={retryFetchIssueTransitions}>
              {intl.formatMessage(messages.tryAgain)}
            </Button>
          </>
        ) : null}
      </styles.LineContainer>
    </styles.ErrorContainer>
  );
};

export default injectIntl(IssueTransitionErrorForm);
